<template>
  <el-row class="f-h">
    <el-container class="f-h mt10" ref="" style="height: 100%;">
      <el-aside width="700px" style="border-right:1px solid #ccc;min-height: 600px;">
        <el-table ref="table" :data="list" v-loading="meta.loading"  highlight-current-row @current-change="handleCurrentChange">
          <el-table-column label="操作" width="100px;" align="center">
            <template slot-scope="{}">
              <!-- <el-button type="text" @click.native.stop="pint(row)">打印</el-button> -->
              <!-- <el-button icon="el-icon-printerh" circle></el-button> -->
              <!-- <el-button icon="el-icon-printer" circle></el-button> -->
              <i class="el-icon-printer" style="font-size: 16px;"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="name">
            <template slot-scope="{row}">
              <span><el-tag type="danger" size="mini">异常</el-tag>{{row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="检测人" prop="doctorName"></el-table-column>
          <el-table-column align="center" label="检测时间" prop="examineDate" width="180px"></el-table-column>
        </el-table>
      </el-aside>
      <el-container style="padding: 10px;overflow: scroll;">
        <el-descriptions title="" :column="1"  direction="vertical" :labelStyle="{fontSize:'16px',fontWeight:'bold',color:'#409eff'}" :contentStyle="{fontSize:'16px',fontWeight:'bold'}">
          <el-descriptions-item label="详细结果" >
            <el-table ref="table" :data="report.items" v-loading="meta.loading" border style="width: 80%;">
              <el-table-column align="center" label="检验指标" prop="name">
                <template slot-scope="{row}">
                  <span>{{row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="结果" prop="result">
                <template slot-scope="{row}">
                  <span v-html="result(row)"></span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="单位" prop="unit" width="180px"></el-table-column>
              <el-table-column align="center" label="参考值" prop="" width="180px">
                <template slot-scope="{row}">
                  <span>{{row.min}}~{{row.max}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-descriptions-item>
          <el-descriptions-item label="详细结果"><el-image :src="report.img" :preview-src-list="[report.img]"></el-image></el-descriptions-item>
          <el-descriptions-item label="检查所见">{{ report.result }}</el-descriptions-item>          
          <el-descriptions-item label="诊断意见">{{ report.diagnosis }}</el-descriptions-item>
      </el-descriptions>
      </el-container>
    </el-container>
  </el-row>
</template>
<script>
import api from "../api"
import { mapGetters } from "sw-hic";
export default {
  props: {
    entity: Object
  },
  data() {
    return {
      infoDetail: {},
      vdate: '',
      selIndex: 0,
      meta: {
        loading: false
      },
      condition: {},
      list: [],
      currentRow:null,
      items:[],
      report:{}
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum", "user"])
  },
  filters: {
  },
  watch: {
    'entity': function (val) {
      if (val && this.open) {
        this.open()
      }
    }
  },
  mounted() {
    this.open()
  },
  methods: {
    open() {
      this.infoDetail = this.$utils.Obj.clone(this.entity)
      this.condition.ipNo = this.infoDetail.ipNo
      this.query()
    },
    dateChange(v) {
      this.condition.startCreateDate = this.$utils.Fmt.datetime(v[0])
      this.condition.endCreateDate = this.$utils.Fmt.datetime(v[1]).replace('00:00:00', '23:59:59')
      // this.init()
    },
    close() {
      this.$emit("update:visible", false);
    },
    query() {
      this.list = [
        {
          name:'血常规',
          doctorName:'张三',
          examineDate:'2022-01-01 :12:12:45',
          examineResult:''
        },
        {
          name:'腹部B超',
          doctorName:'李四',
          examineDate:'2022-01-01',
          examineResult:''
        },
        {
          name:'血糖',
          doctorName:'张三',
          examineDate:'2022-01-01',
          examineResult:'异常'
        }
      ]
      // this.meta.loading = true;
      // api.Billing.query(this.condition)
      //   .then((res) => {
      //     this.$set(this, 'list', res.items)
      //   })
      //   .finally(() => {
      //     this.meta.loading = false;
      //   });
    },
    setCurrent(row) {
        this.$refs.table.setCurrentRow(row);
      },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.getReport()
    },
    getReport(){
      this.report = {
        items:[
          {
            name:'WBC白细胞',
            result:3,
            unit:'mmol/L',
            max:10,
            min:4
            // reference:'4.0-10.0'
          },
          {
            name:'NEUT% 中性细胞粒比率',
            result:3,
            unit:'%',
            max:75,
            min:40
            // reference:'4.0-10.0'
          },
          {
            name:'LYMPH% 淋巴细胞比率',
            result:3,
            unit:'%',
            max:50,
            min:20
            // reference:'4.0-10.0'
          }
        ],
        img:'https://n.sinaimg.cn/sinakd2020113s/167/w600h367/20201103/7eae-kcieyvz9279018.png',
        result:'肝脏大小正常，胆囊大小正常',
        diagnosis:'胆囊肿'
      }
    },
    result(row){
      let {result,min,max} = row
      if(result<min) return `<div style="color:red;">↓${result}</div>`
      else if( result>max) return `<div style="color:red;">↑${result}</div>`
      else return `<div>${result}</div>`
    },
    pint(){}
  }
}
</script>